import { useMemo, useState } from "react";
import useDocumentTitle from "../../utils/useDocumentTitle";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import DataTable from "../../components/DataTable";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import PiiAdminService from "../../services/PiiAdminService";
import styles from "./PiiAdmin.module.scss";

const columns = [
  { id: "pii_type", label: "Type", sortable: false },
  {
    id: "pii_value",
    label: "Decrypted Value",
    sortable: false,
    render: val => <span className={styles.sensitiveValue}>{val}</span>,
  },
  { id: "occurrence_count", label: "Occurrence Count", sortable: false },
  {
    id: "sources",
    label: "Sources",
    sortable: false,
    render: val => (
      <div className={styles.chipList}>
        {(Array.isArray(val) ? val : []).map((source, index) => (
          <span key={index}>{source}</span>
        ))}
      </div>
    ),
  },
  {
    id: "first_seen_at",
    label: "First Seen At",
    sortable: false,
    render: val => (val ? new Date(val).toLocaleString() : "—"),
  },
  {
    id: "last_seen_at",
    label: "Last Seen At",
    sortable: false,
    render: val => (val ? new Date(val).toLocaleString() : "—"),
  },
];

export function PiiOccurrences(props) {
  useDocumentTitle(props.title);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [source, setSource] = useState("");

  const filters = useMemo(
    () => ({
      startDate: startDate || undefined,
      endDate: endDate || undefined,
      source: source || undefined,
    }),
    [startDate, endDate, source]
  );

  return (
    <DashboardLayout isDisableCampaignSelection={true}>
      <PageContent>
        <Section>
          <SectionTitle>PII Occurrences</SectionTitle>

          <div className={styles.filterBar}>
            <label>
              Start date
              <input
                type="date"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
              />
            </label>
            <label>
              End date
              <input
                type="date"
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
              />
            </label>
            <label>
              Source
              <input
                type="text"
                placeholder="e.g. coaching_session"
                value={source}
                onChange={e => setSource(e.target.value)}
              />
            </label>
          </div>

          <DataTable
            columns={columns}
            fetchData={PiiAdminService.getOccurrences}
            filters={filters}
            defaultOrderBy="occurrence_count"
            defaultOrder="desc"
            storageKey="piiOccurrences"
          />
        </Section>
      </PageContent>
    </DashboardLayout>
  );
}
